import { registerPlugin } from "./utils/registerPlugin"
import * as Sentry from "@sentry/core"

const { isReceiptQrCodeEnabled } = useTenant()

type IPrinterPlugin = {
  printStr: (payload: {
    str: string
    footerQrCodeContent?: string
  }) => Promise<void>
}

const rawPlugin: IPrinterPlugin =
  registerPlugin<IPrinterPlugin>("IPrinterPlugin", {
    printStr: (payload: {
      str: string
      footerQrCodeContent?: string
    }) => {
      console.info(payload.str)
      return Promise.resolve()
    },
  })

export const IPrinter: IPrinterPlugin = {
  printStr: async (payload) => {
    try {
      if (!isReceiptQrCodeEnabled.value) {
        delete payload.footerQrCodeContent
      }
      await rawPlugin.printStr(payload)
    } catch (error) {
      if ((error as Error).message === "Out of paper") {
        toast.error(
          "Paper Tray Empty: Refill the paper tray to print the receipt.",
          10000
        )
      } else if (
        (error as Error).message === "Low charge"
      ) {
        toast.error(
          "Device battery is too low to print. Please charge your device and try again.",
          10000
        )
      } else {
        toast.error("Failed to print.")
        Sentry.captureException(error)
      }
    }
  },
}
